import {GET_SEARCH_RESULT} from './actionTypes'

const initialState = {
  searchResult: '',
  // isLoading: false,
  // hasError: false,
  fulfilled: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SEARCH_RESULT:
      return {
        ...state,
        searchResult: action.payload,
        fulfilled: true,
      }

    default:
      return state
  }
};

